export const SDRequest = () =>
{
    return(
        <div
        className="modal fade"
        id="specialDesignRequestPopupModal"
        tabindex="-1"
        aria-labelledby="specialDesignRequestPopupModalLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content">
            <div className="modal-header">
              <h5
                className="modal-title"
                id="specialDesignRequestPopupModalLabel"
              >
                Special Design Request(SDR)
              </h5>
              <i className="fas fa-times" data-dismiss="modal"></i>
            </div>
            <div className="modal-body">
              <div className="row mt-3">
                <div className="col-md-12 mb-2">
                  <div className="d-flex justify-content-between">
                    <label>Upload file</label>
                    <p>
                      <i className="fas fa-plus mr-2"></i>Add File
                    </p>
                  </div>
                  <div className="d-flex">
                    <form id="file-upload-form" className="uploader">
                      <input
                        id="file-upload-attachment"
                        type="file"
                        name="fileUpload"
                        accept=".pdf"
                      />
                      <label for="file-upload-attachment" id="file-drag">
                        <div id="start">
                          <i className="fas fa-paperclip mr-3"></i>
                          <div className="upload-caption">Attach File</div>
                        </div>
                        {/* <div id="start">
                                                        <div className="upload-caption"></div>
                                                        <i className="fas fa-upload float-right" aria-hidden="true"></i>
                                                    </div> */}
                      </label>
                    </form>
                    <button className="btn upload-icon-btn" type="button">
                      <i className="fas fa-upload"></i>
                    </button>
                  </div>
                </div>
                <div className="col-md-12 mb-2">
                  <div>
                    <label>Description</label>
                    <textarea
                      className="form-control"
                      placeholder="Enter"
                      rows="5"
                    ></textarea>
                  </div>
                </div>
                <div className="col-md-12 mb-2">
                  <div>
                    <label>Add noted to factory</label>
                    <textarea
                      className="form-control"
                      placeholder="Enter"
                      rows="5"
                    ></textarea>
                  </div>
                </div>
                <div className="col-md-12 mb-2">
                  <div>
                    <label>Charges</label>
                    <input
                      className="form-control"
                      type="text"
                      placeholder="Price in selected currency"
                    ></input>
                  </div>
                </div>
              </div>
            </div>
            <div className="modal-footer">
              <button
                type="button"
                className="btn back-btn"
                data-dismiss="modal"
              >
                Back
              </button>
              <button
                type="button"
                className="btn save-btn"
                data-dismiss="modal"
              >
                Save
              </button>
            </div>
          </div>
        </div>
      </div>
    )
}